import styled from '@emotion/styled';
import { isNumber } from 'lodash-es';
import { formatNumber } from 'src/components/helper/formatNumber';
import { Bar } from 'src/ui-components';

interface IProps {
  value: number;
}

export const ProgressCell = ({ value }: IProps) => {
  return (
    <Wrapper>
      {isNumber(value) ? (
        <Bar
          size={'sm'}
          value={value * 100}
          endTitle={formatNumber({ value, style: 'percent', decimal: true })}
        />
      ) : (
        'n/a'
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;
